import React from 'react';
import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import Layout from '.';
import {
  useLayoutContext,
  BREAKPOINT_FOR_RIGHT_RAIL_COVER,
} from '../context/LayoutContext';
import useBreakpointStatus from '../hooks/useBreakpointStatus';

const useStyles = makeStyles()(theme => ({
  root: {
    display: 'grid',
    flex: 1,
    gridTemplateAreas: `'header header' 'subheader subheader' 'toolbar toolbar' 'main right'`,
    gridTemplateColumns: `minmax(auto, 100%) 0%`,
    gridTemplateRows: `40px auto auto minmax(auto, 1fr)`,
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      gridTemplateRows: `minmax(0%, auto) auto auto minmax(auto, 1fr)`,
    },
  },
  expandedInlineRightRail: {
    gridTemplateColumns: `minmax(auto, 100%) ${Layout.RIGHT_RAIL_WIDTH}px`,
  },
  /**
   * @note there's some jankiness when using the transition through the switching of the rails.
   *  this attempts to mitigate that by only using the transition when using the inlinerightrail
   */
  withTransition: {
    transition: theme.transitions.create(['grid-template-columns'], {
      easing: 'cubic-bezier(0.25, 0.25, 0.5, 1)',
      duration: 600,
    }),
  },
}));

/**
 * @description A layout component that wraps the main, right, and header components and lays them out.
 */
const Main = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  const { classes, cx } = useStyles();
  const { isRightRailOpen } = useLayoutContext();
  const bpStatus = useBreakpointStatus({
    breakpointToCover: BREAKPOINT_FOR_RIGHT_RAIL_COVER,
  });

  // We should prefer the layered right rail if the screen is at SM or less
  const useLayeredRightRailExpand =
    bpStatus && (bpStatus.isAtBreakpoint || bpStatus.isBelowBreakpoint);

  return (
    <Box
      className={cx(classes.root, className, {
        [classes.expandedInlineRightRail]:
          !useLayeredRightRailExpand && isRightRailOpen,
        [classes.withTransition]: !useLayeredRightRailExpand,
      })}
    >
      {children}
    </Box>
  );
};

export default Main;
